import { Box, Button, Grid, LinearProgress, Typography } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { useState } from "react";

import { useSnackbar } from "../contexts/SnackbarProvider";
import ShowItem from "../components/ShowItem/ShowItem";
import DeleteDialog from "../components/DeleteDialog";
import { useAuth } from "../contexts/AuthContext";
import AddNewPage from "./AddNewPage";
import EditPage from "./EditPage";
import TopSection from "../components/TopSection";
import useIsSmallScreen from "../utils/useIsSmallScreen";

const PagesOfUnit = () => {
  const IS_SMALL_SCREEN = useIsSmallScreen();

  const { setSnackbarDetail } = useSnackbar();
  const navigate = useNavigate();
  let { unitId } = useParams();
  const Auth = useAuth();

  const [showPageStatus, setShowPageStatus] = useState("");
  const [selectedPage, setselectedPage] = useState();
  const [searchText, setSearchText] = useState("");

  const { data: unit, isFetching: isLoadingUnit } = useQuery(
    `api/units/${unitId}`
  );

  const {
    status: allPagesStatus,
    data: allPages,
    isFetching: isLoadingPages,
    refetch: refetchAllPages,
  } = useQuery(`api/page?unitId=${unitId}`);

  async function deletePage() {
    Auth.AuthenticatedServerCall({
      method: "DELETE",
      entity: `api/pages/${selectedPage.id}`,
    })
      .then((res) => {
        setSnackbarDetail({
          open: true,
          message: res.message,
          severity: "success",
        });
        refetchAllPages();
      })
      .catch((e) => {
        setSnackbarDetail({
          open: true,
          message: e.message,
          severity: "error",
        });
        console.log("error: ", e);
      });

    setShowPageStatus("");
    setselectedPage(null);
  }

  function totalVoices(pages) {
    let sum = 0;
    pages?.forEach((page) => {
      page?.images.forEach((image) => {
        sum += image?.buttons?.length;
      });
    });
    return sum;
  }

  if (showPageStatus === "new") {
    return (
      <AddNewPage
        onBack={(refresh) => {
          setShowPageStatus("");
          if (refresh) {
            refetchAllPages();
          }
        }}
        unitId={unitId}
      />
    );
  }

  if (showPageStatus === "edit") {
    return (
      <EditPage
        onBack={(refresh) => {
          setShowPageStatus("");
          setselectedPage(null);
          if (refresh) {
            refetchAllPages();
          }
        }}
        page={selectedPage}
      />
    );
  }

  return (
    <Box className="md-pagesOfUnit">
      <DeleteDialog
        open={showPageStatus === "delete"}
        onClose={() => {
          setShowPageStatus("");
          setselectedPage(null);
        }}
        onDelete={deletePage}
        title={`Are you sure to delete ${selectedPage?.title}?`}
      />

      {unit?.unit?.bookId && (
        <TopSection
          title="Live The Language!"
          searchText={searchText}
          setSearchText={setSearchText}
          numberOfBooks={allPages?.pages?.length}
          numberOfVoices={totalVoices(allPages?.pages)}
          cover={`${process.env.REACT_APP_END_POINT}assets/title/books/book${
            IS_SMALL_SCREEN ? "-mobile" : ""
          }-${unit?.unit?.bookId}.jpg`}
          onBack={() => navigate(`/book/${unit?.unit?.bookId}`)}
        />
      )}

      {isLoadingPages || isLoadingUnit ? (
        <LinearProgress />
      ) : allPagesStatus === "success" && allPages ? (
        <>
          {Auth.loggedInUser?.id && (
            <Button
              sx={{ marginLeft: ".5rem" }}
              variant="contained"
              onClick={() => setShowPageStatus("new")}
            >
              Add new Page
            </Button>
          )}
          <Grid
            container
            rowSpacing={1}
            columnSpacing={1}
            className="topSection"
            alignItems="stretch"
          >
            <Grid item xs={12} md={1} className="center-item"></Grid>
            <Grid item xs={12} md={10} sx={{ display: "block", marginTop: 2 }}>
              <Typography variant="h4" sx={{ mt: 4, mb: 2 }} color="primay">
                {unit?.unit?.title}
              </Typography>
              <Grid
                className="md-homePageBooksList md-GridListContainer"
                container
                item
                rowSpacing={2}
                columnSpacing={2}
                alignItems="stretch"
                sx={{
                  justifyContent: "left",
                  pl: "0px",
                  pr: 0,
                }}
              >
                {allPages?.pages?.map((page) => {
                  return (
                    <Grid
                      item
                      key={page.id}
                      xs={6}
                      md={3}
                      sx={{ width: "100%" }}
                      className="md-gridShowItem"
                    >
                      <ShowItem
                        imageUrl={page?.images?.[0]?.image_url}
                        onEdit={
                          Auth.loggedInUser?.id
                            ? () => {
                                setShowPageStatus("edit");
                                setselectedPage(page);
                              }
                            : undefined
                        }
                        onDelete={
                          Auth.loggedInUser?.id
                            ? () => {
                                setShowPageStatus("delete");
                                setselectedPage(page);
                              }
                            : undefined
                        }
                        onClick={() => {
                          navigate(`/show/${unit?.unit?.id}`, {
                            state: { pageId: page.id },
                          });
                          // setShowPageStatus("show");
                          // setselectedPage(page);
                        }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
            <Grid item xs={12} md={1} className="center-item"></Grid>
          </Grid>
        </>
      ) : (
        <Typography variant="h6">Error on fetching data</Typography>
      )}
    </Box>
  );
};

export default PagesOfUnit;
